import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const [footerSearch, setFooterSearch] = useState('');

  const runSearch = () => {
    const term = footerSearch.trim();

    if (term) {
      navigate(`/search?q=${encodeURIComponent(term)}`);
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      runSearch();
    }
  };

  return (
    <footer className="footer">
      <h2 className="header">Contact Us</h2>

      <div className="footer-content">
        <div className="links-list">
          <ul className="lists">
            <li><a href="/contactus">Request for Intelligence (RFI)</a></li>
            <li><a href="/contactus">Frequently Asked Questions</a></li>
            <li><a href="/privacy">Privacy & Legal</a></li>
          </ul>
        </div>

        <div className="line"></div>

        <div className="contact-info">
          <p>5235 North Front Street</p>
          <p>Harrisburg, PA 17110</p>
          <p>watchroom@ina-inc.com</p>
          <p>+1 717-599-5505</p>
        </div>

        <div className="line"></div>

        <div className="hours">
          <p>Hours</p>
          <p>8:00AM to 4:30PM EST</p>
          <p>Monday – Friday</p>
        </div>
        <div className="line"></div>

<div className="footer-search-column">
  <p className="footer-search-title">Search Orion</p>

  <div className="footer-search">
    <input
      type="text"
      placeholder="Reports, groups, spotlights..."
      value={footerSearch}
      onChange={(e) => setFooterSearch(e.target.value)}
      onKeyDown={handleSearchKeyDown}
    />

    <button type="button" onClick={runSearch}>
      Search
    </button>
  </div>
</div>
      </div>

      

      <div className="copyright-info">
        &copy; 2026 Information Network Associates INC. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;